<span class="history-date">
    <b><span class="history-date-days" translate>{{ days }}</span></b>
    <div><span class="history-date-time">{{ time }}</span></div>
</span>
